import { render, staticRenderFns } from "./PurchaseBackList.vue?vue&type=template&id=10c55af5&scoped=true"
import script from "./PurchaseBackList.vue?vue&type=script&lang=js"
export * from "./PurchaseBackList.vue?vue&type=script&lang=js"
import style0 from "./PurchaseBackList.vue?vue&type=style&index=0&id=10c55af5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c55af5",
  null
  
)

export default component.exports